import { APIResponse, EntityType } from "server-model";
import { AuthenticationService, CachingService, IAMService, UIService } from "src/app/services/services.module";
import { AppServerCRMEntitySearchConnector } from "../../app-server-connectors";
import { CRMEntitySearchConnector } from "./crm-entity-search.connector";
import { Injectable } from "@angular/core";

@Injectable()
export class CRMEntitySearchDataService {
    private crmEntitySearchConnector: CRMEntitySearchConnector;

    constructor(
        private cachingService: CachingService,
        private iamService: IAMService,
        private authenticationService: AuthenticationService,
        private uiService: UIService,
    ) {
        this.crmEntitySearchConnector = new AppServerCRMEntitySearchConnector(this.iamService, this.authenticationService, this.uiService)
    }

    async getSearch(organisationId: string, entityType: EntityType, search: string, start: number, limit: number): Promise<APIResponse> {
        return await this.crmEntitySearchConnector.getSearch(organisationId, entityType, search, start, limit)
    }
}

